import { render, staticRenderFns } from "./TwChatContent.vue?vue&type=template&id=558879c6&"
import script from "./TwChatContent.vue?vue&type=script&lang=js&"
export * from "./TwChatContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports